export type WorkspacePageSectionId =
  | 'summary'
  | 'conversations'
  | 'documents';

export type WorkspacePageSectionState = Record<
  WorkspacePageSectionId,
  boolean
>;

const STORAGE_KEY_PREFIX = 'litium-workspace-page-sections';

export const DEFAULT_WORKSPACE_PAGE_SECTION_STATE: WorkspacePageSectionState =
  {
    summary: true,
    conversations: true,
    documents: true,
  };

export const readWorkspacePageSectionState = (
  workspaceId: string,
): WorkspacePageSectionState => {
  if (!workspaceId) {
    return { ...DEFAULT_WORKSPACE_PAGE_SECTION_STATE };
  }

  try {
    const raw = localStorage.getItem(`${STORAGE_KEY_PREFIX}-${workspaceId}`);
    if (!raw) {
      return { ...DEFAULT_WORKSPACE_PAGE_SECTION_STATE };
    }

    const parsed = JSON.parse(raw) as Record<string, unknown>;
    const next = { ...DEFAULT_WORKSPACE_PAGE_SECTION_STATE };

    for (const key of Object.keys(next) as WorkspacePageSectionId[]) {
      if (typeof parsed[key] === 'boolean') {
        next[key] = parsed[key];
      }
    }

    return next;
  } catch {
    return { ...DEFAULT_WORKSPACE_PAGE_SECTION_STATE };
  }
};

export const writeWorkspacePageSectionState = (
  workspaceId: string,
  state: WorkspacePageSectionState,
): void => {
  if (!workspaceId) return;

  try {
    localStorage.setItem(
      `${STORAGE_KEY_PREFIX}-${workspaceId}`,
      JSON.stringify(state),
    );
  } catch {
    // Ignore quota / privacy errors
  }
};
